import type { ApiClient } from "@/api/client";
import { API_VERSION_PREFIX } from "@/api/client";
import type {
  AdminListResponse,
  ListParams,
  RequestMeta,
  SavedViewDto,
  UserSegmentDto,
} from "./types";

const BASE = `${API_VERSION_PREFIX}/hq/admin`;

function toQuery(params: ListParams = {}): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === "") continue;
    search.set(key, String(value));
  }
  const qs = search.toString();
  return qs ? `?${qs}` : "";
}

export function createAnalyticsApi(client: ApiClient) {
  return {
    listSavedViews(params: ListParams = {}) {
      return client.get<AdminListResponse<SavedViewDto>>(
        `${BASE}/saved-views${toQuery(params)}`,
      );
    },
    getSavedView(id: string) {
      return client.get<{ saved_view: SavedViewDto; meta: RequestMeta }>(
        `${BASE}/saved-views/${id}`,
      );
    },

    listUserSegments(params: ListParams = {}) {
      return client.get<AdminListResponse<UserSegmentDto>>(
        `${BASE}/user-segments${toQuery(params)}`,
      );
    },
    getUserSegment(id: string) {
      return client.get<{ user_segment: UserSegmentDto; meta: RequestMeta }>(
        `${BASE}/user-segments/${id}`,
      );
    },
  };
}

export type AnalyticsApi = ReturnType<typeof createAnalyticsApi>;
